import React from 'react';
import BannerNoInstalacion from '../../layouts/BannerNoInstalacion';

const IntroPisos = () => {
  return (
    <section className="py-4 py-md-5">
      <div className="container">
        <div className="row g-4 g-lg-5 align-items-center">
          
          {/* Columna principal - Contenido y CTA */}
          <div className="col-lg-6 order-1 order-lg-2">
            <div className="ps-lg-3 ps-xl-4">
              {/* Encabezado de sección */}
              <div className="mb-4 mb-md-5">
                <span className="badge bg-primary bg-opacity-10 text-primary mb-3 px-3 py-2">
                  Entrega Inmediata
                </span>
                <h1 className="display-5 fw-bold mb-3 mb-md-4">
                  Recubrimientos para pisos que transforman tus espacios
                </h1>
                <p className="lead text-muted mb-0">
                  En Decototal entendemos que cada proyecto necesita materiales que inspiren, 
                  que sean versátiles y que eleven el diseño con soluciones de instalación 
                  rápida y apariencia impecable. Nuestra colección de recubrimientos para pisos 
                  ofrece una gama cuidadosamente seleccionada de materiales sintéticos y 
                  ecológicos para interiores y exteriores, ideales para todo tipo de ambientes 
                  comerciales y residenciales.
                </p>
              </div>

              {/* Banner CTA */}
              <div className="mb-4">
                <BannerNoInstalacion />
              </div>

              {/* Imagen secundaria - Solo desktop */}
              <div className="d-none d-lg-block rounded overflow-hidden shadow-sm">
                <img 
                  src="/assets/img/recubrimientos-muros/recubrimientos-muros-intro-2.jpg" 
                  alt="Recubrimientos para muros" 
                  className="img-fluid w-100"
                /> 
              </div>
            </div>
          </div>
          
          {/* Columna secundaria - Imagen y características */}
          <div className="col-lg-6 order-2 order-lg-1">
            <div className="pe-lg-3 pe-xl-4">
              {/* Imagen principal */}
              <div className="mb-4 mb-md-5 rounded overflow-hidden shadow">
                <img 
                  src="assets/img/productos/pisos-spc/piso-spc-sala-intro.jpg" 
                  alt="Recubrimientos para pisos que transforman tus espacios" 
                  className="img-fluid w-100"
                />
              </div>

              {/* Características destacadas */}
              <div className="ps-0 ps-md-4 ps-lg-5">
                <FeatureItem
                  imgSrc="/assets/img/icons/icon-flecha-derecha.png"
                  titulo="Fácil instalación"
                  descripcion="Materiales listos para instalación, fáciles de cortar y fijar. Opciones resistentes al agua, humedad y rayos UV."
                />
                <FeatureItem
                  imgSrc="/assets/img/icons/icon-flecha-derecha.png"
                  titulo="Uso en interiores y exteriores"
                  descripcion="Variedad de acabados, colores y texturas para adaptarse a diferentes estilos de diseño, en interior y exterior."
                />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

// Componente optimizado para características
const FeatureItem = ({ imgSrc, titulo, descripcion }) => {
  return (
    <div className="d-flex gap-3 border-bottom border-2 pb-3 pb-md-4 mb-3 mb-md-4 last-child-no-border">
      <div className="flex-shrink-0">
        <img 
          src={imgSrc} 
          alt="" 
          className="d-block"
          style={{ width: '24px', height: '24px' }}
          aria-hidden="true"
        />
      </div>
      <div className="flex-grow-1">
        <h3 className="h5 fw-semibold mb-2">{titulo}</h3>
        <p className="text-muted mb-0 small">{descripcion}</p>
      </div>
    </div>
  );
};

export default IntroPisos;